import { useEffect } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useExcluirAssociacao = ({ onUpdate }) => {
  const {
    request: excluirRequest,
    data: excluirData,
    errors: excluirErrors,
    isLoading: excluirIsLoading,
  } = useApiClient();

  useEffect(() => {
    if (excluirIsLoading) return;

    if (!excluirData && !excluirErrors) return;

    if (excluirData) {
      toast.success("Associação excluída com sucesso!");
      onUpdate();
    }
  }, [excluirData, excluirErrors, excluirIsLoading, onUpdate]);

  const excluirAssociacao = ({ row }) => {
    excluirRequest(apiRoutes.fiscalizacao.ordemservico.excluirtsps, {
      sqAcaoFiscal: row.sqAcaoFiscal,
      SqPessoa: row.sqPessoa,
    });
  };

  return { excluirAssociacao };
};

export default useExcluirAssociacao;
